import { FC, useEffect, useState } from "react";

interface IHelpShift {
  onClose: Function;
}

export const HelpShift: FC<IHelpShift> = (props) => {
  const { onClose } = props;
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    if (isOpen) return;
    window.Helpshift("updateHelpshiftConfig");
    window.Helpshift("open");
  }, []);

  useEffect(() => {
    const widgetToggleEventHandler = (data: { visible: boolean }) => {
      if (!data.visible) {
        onClose();
      }
      setIsOpen(data.visible);
    };
    window.Helpshift(
      "addEventListener",
      "widgetToggle",
      widgetToggleEventHandler,
    );
    return () => {
      window.Helpshift(
        "removeEventListener",
        "widgetToggle",
        widgetToggleEventHandler,
      );
    };
  }, [onClose]);

  return null;
};
